import React, { useEffect, useState } from "react";
import { getOrganization } from "../services/organizationService";
import SectionTitle from "../components/SectionTitle";
import NamasteHero from "../components/NamasteHero";
import Testimonials from "../components/Testimonials";
import "../styles/home.css";

export default function Home() {

  const [ngo, setNgo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {

    const fetchNgo = async () => {
      try {

        const data = await getOrganization();
        setNgo(data);

      } catch (err) {

        console.error("Failed to fetch NGO profile:", err);
        setError("Failed to load NGO data.");

      } finally {

        setLoading(false);

      }
    };

    fetchNgo();

  }, []);

  if (loading) {
    return (
      <p className="home-loading">
        Loading NGO information...
      </p>
    );
  }

  if (error) {
    return (
      <p className="home-loading" style={{ color: "red" }}>
        {error}
      </p>
    );
  }

  return ( 

    <div className="home-page">
      <NamasteHero
  name={
    ngo?.name ||
    "Shri Ramakrishna Vivekananda Jnana Vikasa Shikshana Samste"
  }
  shortName={ngo?.short_name || "SRV"}
/>

      {/* CONTACT SECTION */}

      <section className="home-contact-section">

        <div className="home-contact-grid">

          {ngo?.address && (

            <div className="home-contact-card">

              <h4>Address</h4>

              <p>
                📍{" "}
                <a
                  href={ngo?.map_link || "#"}
                  target="_blank"
                  rel="noreferrer"
                  className="contact-link"
                >
                  {ngo.address}
                </a>
              </p>

            </div>

          )}

          {(ngo?.phone || ngo?.email) && (

            <div className="home-contact-card">

              <h4>Contact</h4>

              {ngo?.phone && (
                <p>
                  📞{" "}
                  <a
                    href={`tel:${ngo.phone}`}
                    className="contact-link"
                  >
                    {ngo.phone}
                  </a>
                </p>
              )}

              <p>
                📞{" "}
                <a href="tel:7829980749" className="contact-link">
                  7829980749
                </a>
              </p>

              <p>
                📞{" "}
                <a href="tel:6363195343" className="contact-link">
                  6363195343
                </a>
              </p>

              {ngo?.email && (
                <p>
                  ✉️{" "}
                  <a
                    href={`mailto:${ngo.email}`}
                    className="contact-link email-link"
                  >
                    {ngo.email}
                  </a>
                </p>
              )}

            </div>

          )}

          <div className="home-contact-card">

            <h4>Location</h4>

            <p>
              📍{" "}
              <a
                href="https://www.google.com/maps/search/?api=1&query=Shree%20Sharada%20Mata%20Public%20School"
                target="_blank"
                rel="noreferrer"
                className="contact-link"
              >
                Shree Sharada Mata Public School
              </a>
            </p>

            <iframe
              title="ngo-location"
              src="https://maps.google.com/maps?q=Shree%20Sharada%20Mata%20Public%20School&t=&z=13&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="200"
              style={{
                border: 0,
                borderRadius: "10px",
                marginTop: "10px"
              }}
              loading="lazy"
            />

            {ngo?.map_link && (
              <a
                href={ngo.map_link}
                target="_blank"
                rel="noreferrer"
                className="map-btn"
              >
                🗺 View on Google Maps
              </a>
            )}

          </div>

        </div>

      </section>

      {/* MAIN CONTENT */}

      <div className="home-section-cards">

        {ngo?.about && (
          <section className="home-section-card">
            <SectionTitle title="About Us" />
            <p>{ngo.about}</p>
          </section>
        )}

        {ngo?.mission && (
          <section className="home-section-card">
            <SectionTitle title="Our Mission" />
            <p>{ngo.mission}</p>
          </section>
        )}

        {ngo?.vision && (
          <section className="home-section-card">
            <SectionTitle title="Our Vision" />
            <p>{ngo.vision}</p>
          </section>
        )}

        {ngo?.objectives && (
          <section className="home-section-card">

            <SectionTitle title="Objectives" />

            <ul className="home-objectives">

              {ngo.objectives
                .split("\n")
                .filter((item) => item.trim())
                .map((item, index) => (

                  <li key={index}>
                    {item}
                  </li>

                ))}

            </ul>

          </section>
        )}

        {(ngo?.registration_number ||
          ngo?.established_date ||
          ngo?.legal_identity) && (

          <section className="home-section-card">

            <SectionTitle title="Organization Transparency" />

            {ngo?.registration_number && (
              <p>
                <strong>Registration Number:</strong> {ngo.registration_number}
              </p>
            )}

            {ngo?.established_date && (
              <p>
                <strong>Established Date:</strong> {ngo.established_date}
              </p>
            )}

            {ngo?.legal_identity && (
              <p>
                <strong>Legal Identity:</strong> {ngo.legal_identity}
              </p>
            )}

          </section>

        )}

      </div>

      {/* TESTIMONIALS */}

      <section className="home-testimonials">

        <SectionTitle title="What People Say About Us" />

        <Testimonials />

      </section>

      {/* FOOTER */}

      <footer className="home-footer">

        © {new Date().getFullYear()} Shri Ramakrishna Vivekananda Jnana Vikasa Shikshana Samste. All rights reserved.

      </footer>

    </div>

  );
}